
const digest = 'ece64df7c3fbc0fb3446c1ebbb15d7a2a181362c0da2bbadf74e9d5427a4dbd8';
const classes = {"header":"_header_xynqn_1","normal":"_normal_xynqn_7"};
const css = `._header_xynqn_1 {
  color: #3C3F9C;
  font-weight: 600;
  font-size: 16px;
}

._normal_xynqn_7 {
  color: #3C3F9C;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  